import { IPaginationRequest, tryEncodePaginationRequestData } from "@common.api";
import axios from "axios";


export function getPaginationHeaders(pagination?: IPaginationRequest): object {
    if (!pagination) return {};
    return { pagination: tryEncodePaginationRequestData(pagination) }
}